import { render, staticRenderFns } from "./CardPeople2.vue?vue&type=template&id=e0dae218"
import script from "./CardPeople2.vue?vue&type=script&lang=js"
export * from "./CardPeople2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports